import React, {Component} from "react"
import PropTypes from "prop-types"

import {ApiForm, FormSection, Field, TitleSection} from "~/components/"
import {Tenant} from "~/utils/ShelfEntities"
import {withTranslation} from "react-i18next"

class NewTenantView extends Component {
  constructor(props) {
    super(props)
    this.state = {subdomain: ""}
  }

  sanitizeSubdomain(event) {
    // only allow letters, numbers, hyphens and underscores
    this.setState({
      subdomain: event.target.value.toLowerCase().replace(/[^a-z1-9-_]/g, "")
    })
  }

  render() {
    return (
      <ApiForm
        for={Tenant}
        id={this.props.match.params.tenantName}
        then="/tenants"
        submitLabel={this.props.t("tenants.detail.submit")}
      >
        <TitleSection>
          <h3>
            {this.props.match.params.tenantName
              ? this.props.t("tenants.detail.titleEdit")
              : this.props.t("tenants.detail.titleNew")}
          </h3>
        </TitleSection>
        <FormSection label={this.props.t("tenants.detail.informations")}>
          <Field
            label={this.props.t("tenants.detail.name")}
            type="Text"
            name="subdomain"
            value={this.state.subdomain}
            onChange={e => this.sanitizeSubdomain(e)}
          />
        </FormSection>
      </ApiForm>
    )
  }
}

NewTenantView.propTypes = {
  match: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}

export default withTranslation()(NewTenantView)



// WEBPACK FOOTER //
// ./src/views/NewTenantView.js